import type { ComponentProps } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const RemainingCharacters: React.FC<
	{
		count: number;
	} & ComponentProps<'div'>
> = ({ count, ...rest }) => {
	return (
		<Text as="div" className="flex justify-end" {...rest}>
			<span className="sr-only">
				{/* FIXME the i18n key should not be sap-specific */}
				<Translate
					value="corgi.sap.ai_description.personal_prompt.a11y.remaining_characters"
					replacements={{ numRemainingCharacters: count }}
				/>
			</span>{' '}
			<div aria-hidden>{count}</div>
		</Text>
	);
};
